export default __webpack_public_path__ + "static/media/section1-bg6.5ebf8424.png";